import { render, staticRenderFns } from "./WorkOrderType.vue?vue&type=template&id=68f3f0b8"
import script from "./WorkOrderType.vue?vue&type=script&lang=ts"
export * from "./WorkOrderType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports